import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["dontShowCheckbox", "player"]

  connect() {
    // When the controller connects, check if the user has seen the welcome message before
    if (!this.hasSeenWelcome()) {
      // If not, show the lightbox after a small delay
      this.openTimer = setTimeout(() => {
        this.open()
      }, 500)
    }
  }

  disconnect() {
    // Leaving the page before the delay is up must not lock the next page's scrolling.
    clearTimeout(this.openTimer)
    document.body.classList.remove('overflow-hidden')
  }

  open() {
    // The player is only loaded when the welcome is actually shown, not on
    // every visit to the dashboard.
    this.playerTarget.src = this.playerTarget.dataset.src
    this.element.classList.remove('hidden')
    // Prevent scrolling on the body
    document.body.classList.add('overflow-hidden')
  }

  close() {
    // Hide the lightbox
    this.element.classList.add('hidden')
    // Allow scrolling again
    document.body.classList.remove('overflow-hidden')
    this.stopVideo()

    // If the "don't show again" checkbox is checked, save this preference
    if (this.dontShowCheckboxTarget.checked) {
      this.savePreference()
    }
  }

  getStarted() {
    this.close()
  }

  // Unloading the frame is the simplest way to stop a video that is playing.
  stopVideo() {
    this.playerTarget.removeAttribute('src')
  }

  savePreference() {
    // Save the preference to localStorage
    localStorage.setItem('hasSeenWelcome', 'true')
  }

  hasSeenWelcome() {
    // Check if the user has seen the welcome message before
    return localStorage.getItem('hasSeenWelcome') === 'true'
  }

  // For testing purposes - can be called from browser console to reset
  reset() {
    localStorage.removeItem('hasSeenWelcome')
  }
}
